import onReady from '../utils/onReady';
import mixitup from 'mixitup';
import $ from 'jquery';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class ProjectsFiltering {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }

    initMixItUp(filter = null, filterItems = null) {
        
        const mixer = mixitup(this.dom.projects, {
            selectors: {
                target: '.project-item'
            },
            animation: {
                //enable: false,
                duration: 500,
            },
            callbacks: {
                onMixStart: (state) => {
                    this.dom.container.classList.add("loading");
                },
                onMixEnd: (state) => {
                    this.dom.container.classList.remove("loading");

                    if (state.hasFailed) {
                        $(".projects-no-results").show();
                    } else {
                        $(".projects-no-results").hide();
                    }
                }
            }
        });

        if(filter) {
            if(filterItems.length === 0) {
                $(".projects-no-results").show();
            }
            mixer.filter(filterItems);
        }
    }

    initRangeFilter() {
        this.dom.range_before.addEventListener("change", (event) => {
            const min_value = event.target.value;
            const max_value = this.dom.range_after.value;
            this.filterByRange(min_value, max_value);
        });
        this.dom.range_after.addEventListener("change", (event) => {
            const min_value = this.dom.range_before.value;
            const max_value = event.target.value;
            this.filterByRange(min_value, max_value);
        });
    }

    initSearchFilter() {
        this.dom.search_input.addEventListener("keyup", (event) => {
           const search_string = event.target.value;
           console.log("Search for..:", search_string);
           if(search_string.length > 0) {
            this.filterBySearch(search_string, false);
           } else {
               this.filterBySearch(search_string, true);
           }
           
        });
    }

    filterByRange(min, max) {
        // Filter the mixed elements
        let projects = $(this.dom.projects).find(".project-item");

        const show = projects.filter(function() {
            let year = $(this).attr('data-year');
            return year >= min && year <= max;
        });

        if(show.length === 0) {
            $(".projects-no-results").show();
        } else {
            $(".projects-no-results").hide();
        }

        // Call mix it up to.. well.. mix it up.
        this.initMixItUp(true, show);
    }

    filterBySearch(search_string, is_empty) {
        let projects = null;
        if(is_empty) {
            projects = $(this.dom.projects).find(".project-item");
        } else{
            projects = $(this.dom.projects).find(".project-item");
        }
        
        const show = projects.filter(function() {
            let search = $(this).attr('data-title');
            return search.toLowerCase().includes(search_string.toLowerCase());
        });
        
        if(show.length === 0) {
            $(".projects-no-results").show();
        } else {
            $(".projects-no-results").hide();
        }
        // Call mix it up to.. well.. mix it up.
        this.initMixItUp(true, show);
    }

    initTriggerFiltering() {
        this.dom.trigger_filtering.addEventListener("click", () => {
            if(this.dom.filter_container.classList.contains("show")) {
                this.dom.filter_container.classList.remove("show");
            } else {
                this.dom.filter_container.classList.add("show");
            }
        });
    }

    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container,
            projects: container.querySelector(".projects__content"),
            range_before: container.querySelector(".range-before"),
            range_after: container.querySelector(".range-after"),
            search_input: container.querySelector(".search-text-filter"),
            trigger_filtering: container.querySelector(".project__filter--trigger-show-hide"),
            filter_container: container.querySelector(".projects__filter__container"),
            all_checkbox: container.querySelector(".all-checkbox"),
            checkbox_toggles: container.querySelectorAll(".checkbox__toggle")
        };

        //this.dom.all_checkbox.checked = true;

        let urlParam = this.getUrlParameter('category');

        this.initMixItUp();
        this.initRangeFilter();
        this.initSearchFilter();
        this.initTriggerFiltering();

        [].forEach.call(this.dom.checkbox_toggles, (checkbox) => {
            checkbox.addEventListener("click", (event) => {
               this.dom.all_checkbox.checked = false;
            });
        });

        this.dom.all_checkbox.addEventListener("click", () => {
            if(this.dom.all_checkbox.checked === true) {
                [].forEach.call(this.dom.checkbox_toggles, (checkbox) => {
                    checkbox.checked = false;
                });
           }
        });

        //Do a search 
        if(urlParam) {
            let allProjectItems = $(this.dom.projects).find(".project-item");
            const projectsToShowFromCategoryFilter = allProjectItems.filter(function() {
                let toggleBy = $(this);
                //console.log(toggleBy);
                return toggleBy.hasClass(urlParam);
            });
            this.initMixItUp(true, projectsToShowFromCategoryFilter);
        }

    }

}


export default ProjectsFiltering;